// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"0d167f68","372":"c53e8e7f","443":"81154841","738":"46e68206","856":"ae319c1a"}[chunkId] + ".chunk.js";
};